import { SectionCard } from './SectionCard';
import { Button } from '@/components/ui/Button';
import { PROFILE_LAYOUT_STRINGS as S } from '@/lib/constants/profile-layout-strings';

export interface ProfileSetupPromptProps {
  /** Opens the one-panel setup form; omitted for viewers who cannot edit. */
  onStart?: () => void;
}

/**
 * Shown in place of the section cards while an investor or partner profile
 * does not exist yet (FR-181): its first save needs every required field, so
 * it is filled in once through one setup panel. Viewers who cannot edit see a
 * plain "not set up yet" note instead.
 */
export function ProfileSetupPrompt({ onStart }: ProfileSetupPromptProps) {
  if (!onStart) {
    return (
      <SectionCard>
        <p className="text-p5 text-subtext">{S.NOT_SET_UP}</p>
      </SectionCard>
    );
  }
  return (
    <SectionCard title={S.SETUP_TITLE} subtitle={S.SETUP_BODY}>
      <Button variant="primary" onClick={onStart}>
        {S.SETUP_ACTION}
      </Button>
    </SectionCard>
  );
}
